// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getMeals, insertMeals, mealsSelector, updateMeals,} from "./mealsSlice";

import {Colors} from "../../../assets/Colors";

const MealsPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const meals = useSelector(mealsSelector);

    useEffect(() => {
        dispatch(
            getMeals({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && meals.isGetSuccess && !meals.isGetFetching) {
            let calc = meals?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = meals.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && meals.isGetSuccess && !meals.isGetFetching) {
            let calc = meals?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = meals.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !meals?.isGetFetching &&
            meals.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = meals?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = meals.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getMeals({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (meals.isGetSuccess) {
                alertService.success(meals.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getMeals({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (meals.isUpdateSuccess) {
                alertService.success(meals.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateMeals({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetMeals(params) {
    //   return dispatch(getMeals(params));
    // }

    function handleInsertMeals(param) {
        setInsertFetch(true);
        const params = {
            MealsName: param.inputOneValue,
        };

        dispatch(insertMeals(params));
    }

    function handleUpdateMeals(param) {
        setUpdateFetch(true);

        const params = {
            MealsName: param.inputOneValue,
            MealsID: currentData.MealsID,
            status: param.status,
        };
        dispatch(updateMeals(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getMeals(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getMeals(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = meals.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? meals.count : newCount,
            search: search,
        };
        dispatch(getMeals(params));

        setPage(1);
        setCount(newCount === "-1" ? meals.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Meals"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Meals"
                                tableData={meals.data}
                                colOneTitle="ID"
                                colOneData="MealsID"
                                colTwoTitle="Nama Meals"
                                colTwoData="MealsName"
                                status="Status"
                                fetching={meals.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Meals"
                        inputOneTitle="Nama Meals"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertMeals}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.MealsID}
                        modal={handleModal}
                        modalTitle="Ubah Meals"
                        inputOneTitle="Nama Meals"
                        inputOneValue={currentData.MealsName}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateMeals}
                    />
                )}
            </div>
        );
    }
};

export default MealsPage;
